<card name="Кнопки">
  <div card content>
    <div class="form-group">
      <h6>Обычные</h6>
      <div class="d-flex justify-content-around flex-wrap">
        <button type="button" class="btn btn-primary">Главный</button>
        <button type="button" class="btn btn-secondary">Вторичный</button>
        <button type="button" class="btn btn-success">Успех</button>
        <button type="button" class="btn btn-danger">Опасность</button>
        <button type="button" class="btn btn-warning">Предупреждение</button>
        <button type="button" class="btn btn-info">Инфо</button>
        <button type="button" class="btn btn-light">Светлый</button>
        <button type="button" class="btn btn-dark">Темный</button>
      </div>
    </div>

    <div class="form-group">
      <h6>Прозрачные</h6>
      <div class="d-flex justify-content-around flex-wrap">
        <button type="button" class="btn rounded-pill btn-outline-primary">Главный</button>
        <button type="button" class="btn rounded-pill btn-outline-secondary">Вторичный</button>
        <button type="button" class="btn rounded-pill btn-outline-success">Успех</button>
        <button type="button" class="btn rounded-pill btn-outline-danger">Опасность</button>
        <button type="button" class="btn rounded-pill btn-outline-warning">Предупреждение</button>
        <button type="button" class="btn rounded-pill btn-outline-info">Инфо</button>
        <button type="button" class="btn rounded-pill btn-outline-light">Светлый</button>
        <button type="button" class="btn rounded-pill btn-outline-dark">Темный</button>
      </div>
    </div>

    <div class="form-group">
      <h6>Заблокированные</h6>
      <div class="d-flex justify-content-around flex-wrap mb-4">
        <button type="button" disabled class="btn rounded-pill btn-primary">Главный</button>
        <button type="button" disabled class="btn rounded-pill btn-secondary">Вторичный</button>
        <button type="button" disabled class="btn rounded-pill btn-success">Успех</button>
        <button type="button" disabled class="btn rounded-pill btn-danger">Опасность</button>
        <button type="button" disabled class="btn rounded-pill btn-warning">Предупреждение</button>
        <button type="button" disabled class="btn rounded-pill btn-info">Инфо</button>
        <button type="button" disabled class="btn rounded-pill btn-light">Светлый</button>
        <button type="button" disabled class="btn rounded-pill btn-dark">Темный</button>
      </div>
      <div class="d-flex justify-content-around flex-wrap">
        <button type="button" disabled class="btn rounded-pill btn-outline-primary">Главный</button>
        <button type="button" disabled class="btn rounded-pill btn-outline-secondary">Вторичный</button>
        <button type="button" disabled class="btn rounded-pill btn-outline-success">Успех</button>
        <button type="button" disabled class="btn rounded-pill btn-outline-danger">Опасность</button>
        <button type="button" disabled class="btn rounded-pill btn-outline-warning">Предупреждение</button>
        <button type="button" disabled class="btn rounded-pill btn-outline-info">Инфо</button>
        <button type="button" disabled class="btn rounded-pill btn-outline-light">Светлый</button>
        <button type="button" disabled class="btn rounded-pill btn-outline-dark">Темный</button>
      </div>
    </div>

    <div class="form-group">
      <h6>Размеры</h6>
      <div class="row align-items-center">
        <div class="col-40">
          <div class="d-flex">
            <input type="text" class="form-control rounded-pill form-control-lg" placeholder="Контрол">
            <button type="button" class="btn rounded-pill btn-primary btn-lg" style="margin-left: -35px">Большая</button>
          </div>
        </div>

        <div class="col-40">
          <div class="d-flex">
            <input type="text" class="form-control rounded-pill" placeholder="Контрол">
            <button type="button" class="btn rounded-pill btn-primary" style="margin-left: -35px">Средняя</button>
          </div>
        </div>

        <div class="col-40">
          <div class="d-flex">
            <input type="text" class="form-control rounded-pill form-control-sm" placeholder="Контрол">
            <button type="button" class="btn rounded-pill btn-primary btn-sm" style="margin-left: -35px">Маленькая</button>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <h6>Размеры с иконкой</h6>

      <div class="row align-items-center">
        <div class="col-40 d-flex">
          <button type="button" class="btn btn-icon btn-lg rounded-pill btn-primary mr-3">
            <icon-plus></icon-plus>
            <span class="ml-2">Добавить</span>
          </button>

          <button type="button" class="btn btn-icon btn-lg rounded-pill btn-outline-primary mr-3">
            <icon-plus></icon-plus>
            <span class="ml-2">Добавить</span>
          </button>
        </div>

        <div class="col-40 d-flex">
          <button type="button" class="btn btn-icon rounded-pill btn-primary mr-3">
            <span class="mr-2">Добавить</span>
            <icon-arrow></icon-arrow>
          </button>

          <button type="button" class="btn btn-icon rounded-pill btn-outline-primary mr-3">
            <span class="mr-2">Добавить</span>
            <icon-arrow></icon-arrow>
          </button>
        </div>

        <div class="col-40 d-flex">
          <button type="button" class="btn btn-icon btn-sm rounded-pill btn-primary mr-3">
            <span class="mr-2">Добавить</span>
            <icon-arrow></icon-arrow>
          </button>

          <button type="button" class="btn btn-icon btn-sm rounded-pill btn-outline-primary">
            <span class="mr-2">Добавить</span>
            <icon-arrow></icon-arrow>
          </button>
        </div>
      </div>
    </div>

    <div class="form-group">
      <h6>Размеры с иконкой без текста</h6>

      <div class="row align-items-center">
        <div class="col-40 d-flex">
          <button type="button" class="btn btn-square btn-lg btn-primary mr-3">
            <icon-plus [style.width.px]="14"></icon-plus>
          </button>

          <button type="button" class="btn btn-square btn-lg btn-secondary mr-3">
            <icon-plus [style.width.px]="14"></icon-plus>
          </button>
        </div>

        <div class="col-40 d-flex">
          <button type="button" class="btn btn-square btn-success mr-3">
            <icon-plus [style.width.px]="14"></icon-plus>
          </button>

          <button type="button" class="btn btn-square btn-danger mr-3">
            <icon-plus [style.width.px]="14"></icon-plus>
          </button>
        </div>

        <div class="col-40 d-flex">
          <button type="button" class="btn btn-square btn-sm btn-warning mr-3">
            <icon-plus [style.width.px]="14"></icon-plus>
          </button>

          <button type="button" class="btn btn-square btn-sm btn-info">
            <icon-plus [style.width.px]="14"></icon-plus>
          </button>
        </div>
      </div>
    </div>
  </div>
</card>
